const storeData = (name ,value) => {
  localStorage.setItem(name, value);
};
const getLocalStorageData = (name) => {
  let item = localStorage.getItem(name);
  return item;
};
const removeLocalStorageData = () => {
  // localStorage.removeItem(value);
   localStorage.clear();
};

const removeKeyData = (key) =>{
    localStorage.removeItem(key);
}

export { storeData, getLocalStorageData, removeLocalStorageData, removeKeyData};
